import { DialogProps } from '@radix-ui/react-dialog';
import dynamic from 'next/dynamic';

export type CashoutDialogProps = DialogProps & {
  title: string;
  titleError: string;
  text?: string;
  idBiglietto: string;
  importo?: number;
};

export const CashoutDialog = dynamic<CashoutDialogProps>(
  () => import('components/cashoutDialog/CashoutDialog').then((mod) => mod.CashoutDialog),
  { ssr: false }
);
